import React, { useState } from "react";
import { Box, Typography, Modal } from "@mui/material";
import Banner1 from "../images/g4.jpeg";
import Banner3 from "../images/banner3.jpg";
import image2 from "../images/top2.jpeg";
import image6 from "../images/g5.jpeg";
import image7 from "../images/Food3.jpeg";
import image9 from "../images/g6.jpeg";
import image10 from "../images/g1.jpeg";
import image11 from "../images/g2.jpeg";
import image12 from "../images/g1.jpg";
import image13 from "../images/g2.jpg";
import image14 from "../images/g3.jpg";
import image15 from "../images/g4.jpg";
import image16 from "../images/g5.jpg";
import image17 from "../images/g6.jpg";

function Gallery() {
  // Gallery images
  const images = [
    image10,
    image2,

    image7,
    image6,

    Banner3,
    image9,

    Banner1,
    image11,

    image12,
    image13,

    image14,
    image15,

    image16,
    image17,

  ];

  // State for handling modal open/close and the selected image
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };


  return (
    <>
      <Box   >
      
      <Box 
  sx={{ 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
            mb: 16,
      overflow: "hidden"
  }}
>
  <Typography
    variant="h3"
    style={{
      fontFamily: "SangBleu Empire Trial",
      fontWeight: "bold",
      fontSize: "55px",
      lineHeight: "1",
      display: "inline-block",
    }}
    sx={{ mx: 2 }} // Add space on both sides of the text
  >
    Gallery
  </Typography>
  <Box
    sx={{
      width: '38px', // Length of the line
      height: '5px', // Thickness of the line
            backgroundColor: '#FF0000', // Color of the line
      mt:5,
    }}
  />
</Box>
      

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)", // 4 columns
          gap: 1, // Spacing between images
          px: 4, // Horizontal padding
        }}
      >
        {/* First Column */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Box
            component="img"
            src={images[0]}
            alt="Gallery Image 1"
            sx={{
              width: "100%",
              height: "120%", // For vertical images, height is 120%
              objectFit: "cover",
              transition: "transform 0.3s ease-in-out", // Add smooth transition
              "&:hover": {
                transform: "scale(1.1)", // Apply zoom effect on hover
              },
              
            }}
            onClick={() => handleOpen(images[0])}
          />
          <Box
            component="img"
            src={images[8]}
            alt="Gallery Image 2"
            sx={{
              width: "100%",
              height: "100%", // For horizontal images, height is 90%
              objectFit: "cover",
              // mb: -12,
              transition: "transform 0.3s ease-in-out", // Add smooth transition
      "&:hover": {
        transform: "scale(1.1)", // Apply zoom effect on hover
      },
            }}
            onClick={() => handleOpen(images[8])}
            />
              <Box
            component="img"
            src={images[12]}
            alt="Gallery Image 2"
            sx={{
              width: "100%",
              height: "120%", // For horizontal images, height is 90%
              objectFit: "cover",
              mb: -12,
              transition: "transform 0.3s ease-in-out", // Add smooth transition
      "&:hover": {
        transform: "scale(1.1)", // Apply zoom effect on hover
      },
            }}
            onClick={() => handleOpen(images[12])}
          />
        </Box>

        {/* Second Column */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Box
            component="img"
            src={images[2]}
            alt="Gallery Image 3"
            sx={{
              width: "100%",
              height: "120%", // For vertical images, height is 120%
              objectFit: "cover",
              mt: -8,
              transition: "transform 0.3s ease-in-out", // Add smooth transition
              "&:hover": {
                transform: "scale(1.1)", // Apply zoom effect on hover
              },
            }}
            onClick={() => handleOpen(images[2])}
          />
          <Box
            component="img"
            src={images[9]}
            alt="Gallery Image 4"
            sx={{
              width: "100%",
              height: "120%", // For vertical images, height is 120%
              objectFit: "cover",
              // mb: -8,
              transition: "transform 0.3s ease-in-out", // Add smooth transition
      "&:hover": {
        transform: "scale(1.1)", // Apply zoom effect on hover
      },
            }}
            onClick={() => handleOpen(images[9])}
            />
             <Box
            component="img"
            src={images[13]}
            alt="Gallery Image 4"
            sx={{
              width: "100%",
              height: "120%", // For vertical images, height is 120%
              objectFit: "cover",
              mb: -8,
              transition: "transform 0.3s ease-in-out", // Add smooth transition
      "&:hover": {
        transform: "scale(1.1)", // Apply zoom effect on hover
      },
            }}
            onClick={() => handleOpen(images[13])}
            />

        </Box>

        {/* Third Column */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Box
            component="img"
            src={images[4]}
            alt="Gallery Image 5"
            sx={{
              width: "100%",
              height: "120%", // For vertical images, height is 120%
              objectFit: "cover",
              transition: "transform 0.3s ease-in-out", // Add smooth transition
      "&:hover": {
        transform: "scale(1.1)", // Apply zoom effect on hover
      },
            }}
            onClick={() => handleOpen(images[4])}
          />
          <Box
            component="img"
            src={images[5]}
            alt="Gallery Image 6"
            sx={{
              width: "100%",
              height: "120%", // For vertical images, height is 120%
              objectFit: "cover",
              // mb: -12,
              transition: "transform 0.3s ease-in-out", // Add smooth transition
      "&:hover": {
        transform: "scale(1.1)", // Apply zoom effect on hover
      },
            }}
            onClick={() => handleOpen(images[5])}
            />
             <Box
            component="img"
            src={images[11]}
            alt="Gallery Image 6"
            sx={{
              width: "100%",
              height: "120%", // For vertical images, height is 120%
              objectFit: "cover",
              mb: -12,
              transition: "transform 0.3s ease-in-out", // Add smooth transition
      "&:hover": {
        transform: "scale(1.1)", // Apply zoom effect on hover
      },
            }}
            onClick={() => handleOpen(images[11])}
          />
        </Box>

        {/* Fourth Column */}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Box
            component="img"
            src={images[6]}
            alt="Gallery Image 7"
            sx={{
              width: "100%",
              height: "90%", // For horizontal images, height is 90%
              objectFit: "cover",
              mt: -8,
              transition: "transform 0.3s ease-in-out", // Add smooth transition
      "&:hover": {
        transform: "scale(1.1)", // Apply zoom effect on hover
      },
            }}
            onClick={() => handleOpen(images[6])}
          />
          <Box
            component="img"
            src={images[7]}
            alt="Gallery Image 8"
            sx={{
              width: "100%",
              height: "120%", // For vertical images, height is 120%
              objectFit: "cover",
              transition: "transform 0.3s ease-in-out", // Add smooth transition
      "&:hover": {
        transform: "scale(1.1)", // Apply zoom effect on hover
      },
            }}
            onClick={() => handleOpen(images[7])}
            />
             <Box
            component="img"
            src={images[10]}
            alt="Gallery Image 8"
            sx={{
              width: "100%",
              height: "120%", // For vertical images, height is 120%
              objectFit: "cover",
              transition: "transform 0.3s ease-in-out", // Add smooth transition
      "&:hover": {
        transform: "scale(1.1)", // Apply zoom effect on hover
      },
            }}
            onClick={() => handleOpen(images[10])}
          />
        </Box>
      </Box>

      {/* Modal to show enlarged image */}
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        }}
      >
        <Box
          sx={{
            maxWidth: "50%",   // Set width to 50% of the screen
            maxHeight: "50%",  // Set height to 50% of the screen
            overflow: "hidden",
            backgroundColor: "white",
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.5)",
          }}
        >
          <Box
            component="img"
            src={selectedImage}
            alt="Enlarged view"
            sx={{
              width: "100%",  // Make the image width 100% of the modal size
              height: "100%", // Make the image height 100% of the modal size
              objectFit: "contain", // Keep the image aspect ratio
            }}
          />
        </Box>
      </Modal>
     </Box>
    </>
  );
}

export default Gallery;
